import { PhosphorGearAnchor } from "components/Atoms/PhosphorIconAnchor";
import { Message } from "semantic-ui-react";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";

export const ConfigureICalendarTemplateMessageBox = () =>
  <Message clolor="blue" className="flex">
    <div className="grow1 padding">
      {RESX.Template.ConfigureICalendarTemplate}
    </div>
    <PhosphorGearAnchor
      href={routes.iCalendarTemplate_List().absolute}
      layout="in-square"
      backgroundColor="transparent"
    />
  </Message>
